import * as H from "history";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { IRootState } from "../../../../store";
import DispatchProps from "../../../../utils/DispatchProps";
import LinkCard from "../../../LinkCard";
import MailroomSchool from "../../../mailroom/MailroomSchool";
import SchoolPageTitle from "../../../SchoolPageTitle";
import AdminSchoolMenu from "../../../AdminSchoolMenu";

interface MisDataPageProps {
    tenantId: string;
    schoolCode: string;

    history: H.History;
}

interface MisDataPageState {

}

class MisDataPage extends Component<MisDataPageProps & DispatchProps, MisDataPageState> {

    constructor(props: MisDataPageProps & DispatchProps) {
        super(props);

        this.state = {
            mailroomSchoolConfig: undefined,
            addInProgress: false
        };
    }

    async componentDidUpdate(prevProps: Readonly<MisDataPageProps & DispatchProps>, prevState: Readonly<MisDataPageState>, snapshot?: any): Promise<void> {

    }

    async componentDidMount() {

    }

    render() {
        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="MIS Data" />

                <AdminSchoolMenu tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} />

                <MailroomSchool title={"MIS Data"} schoolCode={this.props.schoolCode} tenantId={this.props.tenantId} enableLinkToSchool={true}>
                </MailroomSchool>

                <div className={"flex-row"}>
                    <LinkCard title={"School Server (Inbox)"}
                              to={`/cdb-admin/mailroom/salamander/${this.props.tenantId}/${this.props.schoolCode}/inbox`}
                              iconName={"ServerEnviroment"}
                              description={"Browse data uploaded from the school's server"}/>
                        <LinkCard title={"CDB Cloud"}
                                  to={`/cdb-admin/mis-fetch/${this.props.tenantId}/${this.props.schoolCode}`}
                                  iconName={"CloudImportExport"}
                                  description={"Fetch data without a school server"}/>
                </div>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: { history: H.History, match: any }): MisDataPageProps => {

        const tenantId = ownProps.match.params.tenantId;
        const schoolCode = ownProps.match.params.schoolCode;

        return {
            tenantId: tenantId,
            schoolCode: schoolCode,
            history: ownProps.history,
        };
    }
)(MisDataPage);